export default __webpack_public_path__ + "static/media/vitamin_injection_or_infusion.23ba0e5a.pdf";